import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { useHistory } from 'react-router-dom';
import Link from '@mui/material/Link';
import Sidebar from './Sidebar';
import { DEFAULT_LINK_CLASS_NAME } from '../../theme/constants/link';

const TitledSidebar = ({ title, sidebarProps, useBackLink, backLabel, backPath }) => {
  const history = useHistory();
  return (

    <Stack sx={{ mx: 10, mt: 4 }} height="100%" spacing={1.8}>
      {useBackLink && (
      <Link
        onClick={() => history.push(backPath)}
        className={DEFAULT_LINK_CLASS_NAME}
      >
        <Typography variant="small_1" fontWeight={700}>
          {`< ${backLabel}`}
        </Typography>
      </Link>
      )}
      <Typography variant="xlarge_1" fontWeight={700} sx={{ ml: 1 }}>{title}</Typography>
      <Divider sx={{ borderColor: 'gray.A200', borderBottomWidth: 2 }} />
      <Sidebar {...sidebarProps} />
    </Stack>
  );
};

TitledSidebar.propTypes = {
  title: PropTypes.string.isRequired,
  sidebarProps: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.element,
      component: PropTypes.element,
      showAtBottom: PropTypes.bool,
    })),
    showLogOut: PropTypes.bool,
    goBack: PropTypes.bool,
    useHideDrawer: PropTypes.bool,
  }),
  useBackLink: PropTypes.bool,
  backLabel: PropTypes.string,
  backPath: PropTypes.string,
};

TitledSidebar.defaultProps = {
  sidebarProps: {},
  useBackLink: false,
  backLabel: 'Volver',
  backPath: '/app',
};

export default TitledSidebar;
